<template lang="pug">
	v-layout(align-start)
		v-card.pa-7(width='96vw' outlined)
			h1(align='left') Reporte de Gerencia
				v-row(dense)
					v-col(cols='6' sm='6' md='6')
						v-text-field(
									v-model='fechaDesde',
									label='Desde',
									prepend-icon='event',
									readonly,
									dense,
									outlined)
						//- v-dialog(
						//- 	ref='dialog1',
						//- 	v-model='modalDate1',
						//- 	:return-value.sync='date',
						//- 	readonly,
						//- 	persistent,
						//- 	width='300px')
							//- template(v-slot:activator='{ on }')

									//- v-on='on'
							//- v-date-picker(v-model='fechaDesde' locale="ES")
							//- 	v-spacer
							//- 	v-btn(small, dark, color='red,' @click='modalDate1 = false') Cancelar
							//- 	v-btn(small, dark, color='success', @click='$refs.dialog1.save(date)') Ok
					v-col(cols='6' sm='6' md='6')
						v-text-field( v-model='fechaHasta' label='Hasta' prepend-icon='event' readonly dense outlined)
						//- v-dialog(
						//- 	ref='dialog2',
						//- 	v-model='modalDate2',
						//- 	:return-value.sync='date',
						//- 	readonly,
						//- 	persistent,
						//- 	width='300px')
							//- template(v-slot:activator='{ on }')

									//- v-on='on'
							//- v-date-picker( v-model='fechaHasta' locale="ES")
							//- 	v-spacer
							//- 	v-btn(small dark color='red' @click='modalDate2 = false') Cancelar
							//- 	v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
				v-row(dense class='d-flex justify-center mb-10')
					v-btn(@click='getReporte' color='primary' dark) Generar
		v-dialog(v-model='dialog' scrollable persistent min-width="90%")
			v-card
				//- v-toolbar(dark color='primary')
				//-   v-toolbar-title Vista Previa
				v-card-text
					v-container(id="reporteLibro")
						v-row(dense)
							v-col(cols=6)
								p(style="margin-bottom: 2%; color: black;") Almacen 2020
								p(style="margin-bottom: 2%; color: black;") Fecha Desde {{ fechaDesde }} hasta {{ fechaHasta }}
							v-col(cols=6)
								p(style="text-align: end; margin-bottom: 2%; color: black;") Usuario: {{ $store.state.usuario.nombre }}
								//- p(style="text-align: end; margin-bottom: 2%; color: black;") Pagina
								p(style="text-align: end; margin-bottom: 2%; color: black;") Fecha: {{ date }}
						v-row(align="center" justify="center")
							v-col(cols="12" sm="4")
								h4(style="text-decoration: underline black; color: black;") RESUMEN DE CAJAS Y BANCOS
						//- v-row(dense)
						//- 	v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
						//- 		v-row(dense)
						//- 			v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
						//- 				p(style="margin-bottom: 2%; color: black;") EFECTIVO
						//- 				p(style="margin-bottom: 2%; color: black;") EFECTIVO
						//- 				p(style="margin-bottom: 2%; color: black;") Transferencia
						//- 			v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
						//- 				p(style="margin-bottom: 2%; color: black;") CAJA DOLAR
						//- 				p(style="margin-bottom: 2%; color: black;") CAJA NK01 (VALERA)
						//- 				p(style="margin-bottom: 2%; color: black;") BANCO VZLA
						//- 	v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
						//- 		p(style="text-align: center; color: black;") 27,00
						//- 		p(style="text-align: center; color: black;") 0,00
						//- 		p(style="text-align: center; color: black;") 105,26  
						//- 		p(style="text-align: center; color: black;") 132,06
						v-row(dense)
							v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
								v-row(dense)
									v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
										p(style="color: black;") Total Ventas:
										p(style="color: black;") Total Devoluciones:
										p(style="color: black;") Total de Clientes:
										p(style="color: black;") Total de Transacciones:
									v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
										p(style="color: black;") {{ libroVentas.totalVentas }}
										p(style="color: black;") {{ libroVentas.totalDevoluciones }}
										p(style="color: black;") {{ libroVentas.totalClientes }}
										p(style="color: black;") {{ libroVentas.totalTransacciones }}
						v-row(dense)
							v-data-table(
								:headers="headersTransaccion",
								:items="transaccionesDias.array || []",
								dense,
								disable-sort,
								hide-default-footer,
								style="width: 100%;" )
								template(v-slot:top)
									h3 Transacciones del día
								template(v-slot:body.append)
									tr
										th
										th 
										th(style="border-top: 1px solid black;") {{ transaccionesDias.montoNetoTotal }}
										th(style="border-top: 1px solid black;") {{ transaccionesDias.contadoTotal }}
										th(style="border-top: 1px solid black;") {{ transaccionesDias.creditoTotal }}
						p
						//- v-row(dense)
						//- 	v-data-table(:headers="headersRecibos", dense, hide-default-footer, style="width: 100%;" )
						//- 		template(v-slot:top)
						//- 			h3 Recibos de Caja
						//- p
						v-row(dense)
							v-data-table(
								:headers="headersProductos",
								:items="productosFacturas.array || []",
								dense,
								disable-sort,
								hide-default-footer,
								style="width: 100%;")
								template(v-slot:top)
									h3 Producto Facturas
								template(v-slot:body.append)
									tr
										th
										th 
										th(style="border-top: 1px solid black;") {{ productosFacturas.cantidadTotal }}

						v-row(dense)
							v-col(cols=6)
								v-row(dense)
									v-col(cols=6)
										p(style="color: black;") Total CXC Clientes:
										//- p(style="color: black;") Total CXC empleados:
									v-col(cols=6)
										p(style="color: black;") {{ libroVentas.totalCXCCli }}
										//- p(style="color: black;") 1.287,31
						p
						v-row(align="center" justify="center")
							v-col(cols="12" sm="4")
								h4(style="text-decoration: underline black; color: black;") RESUMEN DE INVENTARIO
						v-row(dense)
							v-col(cols=6)
								v-row(dense)
									v-col(cols=6)
										p(style="color: black;") Inventario Inicial (UND):
										p(style="color: black;") Inventario Inicial (COSTO):
										p(style="color: black;") Inventario Inicial (VENTA):
									v-col(cols=6)
										p(style="color: black;") {{ invInicial.cantidadInicial || '' }}
										p(style="color: black;") {{ invInicial.costoInicial || '' }}
										p(style="color: black;") {{ invInicial.precioInicial || '' }}
							v-col(cols=6)
								v-row(dense)
									v-col(cols=6)
										p(style="color: black;") Inventario Final (UND): 
										p(style="color: black;") Inventario Final (COSTO):
										p(style="color: black;") Inventario Final (Venta): 
									v-col(cols=6)
										p(style="color: black;") {{ invFinal.cantidadFinal || '' }}
										p(style="color: black;") {{ invFinal.costoFinal || '' }}
										p(style="color: black;") {{ invFinal.precioFinal || '' }}          
				v-card-actions
					v-spacer
					v-btn(color='error' small dark @click='dialog = false')
						v-icon mdi-close
						| Cancelar
					v-btn(color='success' small dark @click="imprimirPDF")
						v-icon mdi-content-save
						| Imprimir
</template>

<script>
import Api from '@/services/methods';
import printJS from 'print-js';
export default {
	name: "ReporteGerencia",
	data: () => ({
		dialog: false,
		dialog1: false,
		dialog2: false,
		modalDate1: false,
		modalDate2: false,
		date: new Date().toISOString().substr(0, 10),
		fechaDesde: '',
		fechaHasta: '',
		headersTransaccion: [
			{ text: 'DOCUMENTO' , value: 'documento' },
			{ text: 'DESCRIPCION', value: 'descripcion' },
			{ text: 'MONTO NETO', value: 'montoNeto' },
			{ text: 'CONTADO', value: 'contado' },
			{ text: 'CREDITO', value: 'credito' },
		],
		headersRecibos: [
			{ text: 'COBRADOR' },
			{ text: 'CLIENTE' },
			{ text: 'COBRO' },
			{ text: 'TOTAL' },
			{ text: 'EFECTIVO' },
			{ text: 'TRANSFERENCIA' },
		],
		headersProductos: [
			{ text: 'CODIGO', value: 'codigo' },
			{ text: 'DESCRIPCION', value: 'descripcion' },
			{ text: 'CANTIDAD', value: 'cantidad' },
		],
		libroVentas: {},
		productosFacturas: {},
		transaccionesDias: {},
		invInicial: {},
		invFinal: {}
	}),

	created() {
		this.fechaDesde = this.date;
		this.fechaHasta = this.date;
	},
	
	methods: {
		imprimirPDF () {
			printJS({
				printable: 'reporteLibro',
				type: 'html',
				targetStyles: ['*'],
				maxWidth: "100%",
				documentTitle: "Libro de Ventas",
				// header: '<h3 class="custom-h3">My custom header</h3>',
				// style: `
				//   .custom-h3:after { 
				//     display: table-header-group;
				//     counter-increment: page;
				//     content: "pagina: " counter(page);
				//   }
				// `
			})
		},

		getReporte () {
			this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })
			Api.get(`reportes/ReporteGerencia/${this.fechaDesde}/${this.fechaHasta}`)
					.then(res => {
						this.$swal.close();
						this.libroVentas = res.data.libroVentas;
						this.productosFacturas = res.data.productosFacturas;
						this.transaccionesDias = res.data.transaccionesDias;
						this.invInicial = res.data.resumenInventario.invInicial[0] || {};
						this.invFinal = res.data.resumenInventario.invFinal[0] || {};
						this.dialog = true;
					})
	        .catch(error => {
	          if (error.response) {
	            this.$swal({
	              icon: 'error',
	              title: 'Error al cargar',
	             // text: 'Por favor, verifique los datos e intente de nuevo'
	            })
	          } else if (error.request) {
	            this.$swal({
	              icon: 'error',
	              title: 'Error de red',
	              text: 'Por favor verique su conexion de internet'
	            })
	          } else {
	            console.log('Error', error.message);
	          }
	        })
		}

	}
}
</script>

<style lang="scss">
#reporteLibro {
	p {
		margin-bottom: 2%;
	}
	.v-data-table {
		border-bottom: 0px;
		background-color: transparent;
		.v-data-table-header {
			background-color: lightgray;
			tr {
				th {
					span {
						font-weight: bolder;
					}
				}
			}
		}
	}
	.theme--light.v-data-table thead tr:last-child th {
		border-bottom: 0px;
	}
	.theme--light.v-data-table thead tr th {
		color: black;
		font-weight: bold
	}
	.theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
		border-bottom: 0px;
	}
	.theme--light.v-data-table tbody tr:not(:last-child) td:last-child {
		border-bottom: 0px;
	}
}
</style>